export const CONNECTOR_OAUTH_EVENT = 'praxys:connector-oauth-complete';
export const CONNECTOR_OAUTH_MESSAGE_TYPE = CONNECTOR_OAUTH_EVENT;
export const CONNECTOR_OAUTH_POPUP_STATE_KEY = 'praxys_connector_oauth_popup_state';
export const CONNECTOR_OAUTH_RESULT_KEY = 'praxys_connector_oauth_result';

export const getConnectorOAuthRedirectUri = (): string =>
  new URL('/', window.location.origin).toString();

export const hasConnectorOAuthParams = (search: string): boolean => {
  const params = new URLSearchParams(search);
  if (!params.get('state')) return false;
  return Boolean(params.get('code') || params.get('installation_id') || params.get('error'));
};

export const rememberConnectorOAuthPopup = (authUrl: string): void => {
  try {
    const state = new URL(authUrl).searchParams.get('state');
    if (state) localStorage.setItem(CONNECTOR_OAUTH_POPUP_STATE_KEY, state);
  } catch {
    // Best-effort only; OAuth still works without popup auto-close.
  }
};

export const isRememberedConnectorOAuthPopup = (search: string): boolean => {
  try {
    const state = new URLSearchParams(search).get('state');
    return Boolean(state && localStorage.getItem(CONNECTOR_OAUTH_POPUP_STATE_KEY) === state);
  } catch {
    return false;
  }
};

export const clearRememberedConnectorOAuthPopup = (): void => {
  try {
    localStorage.removeItem(CONNECTOR_OAUTH_POPUP_STATE_KEY);
  } catch {
    // Best-effort cleanup.
  }
};

export const broadcastConnectorOAuthResult = (payload: unknown): void => {
  try {
    localStorage.setItem(CONNECTOR_OAUTH_RESULT_KEY, JSON.stringify({ payload, at: Date.now() }));
  } catch {
    // Parent window polling still refreshes if storage is unavailable.
  }
};
